var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 23.6109H16.875C17.9063 23.6109 18.75 22.7672 18.75 21.7359V12.3609H21.7313C23.4 12.3609 24.2437 10.3359 23.0625 9.15469L14.4563 0.548437C13.725 -0.182812 12.5438 -0.182812 11.8125 0.548437L3.20625 9.15469C2.025 10.3359 2.85 12.3609 4.51875 12.3609H7.5V21.7359C7.5 22.7672 8.34375 23.6109 9.375 23.6109ZM1.875 27.3609H24.375C25.4063 27.3609 26.25 28.2047 26.25 29.2359C26.25 30.2672 25.4063 31.1109 24.375 31.1109H1.875C0.84375 31.1109 0 30.2672 0 29.2359C0 28.2047 0.84375 27.3609 1.875 27.3609Z",
    fill: "#3A61FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.19bbe63f2248d7d9a86a006c31f21b1f.svg";
export { ForwardRef as ReactComponent };